import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { ProductPriceListConversion } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductPriceListConversionService extends TmsWebBaseEditCreateService<
  ProductPriceListConversion,
  ProductPriceListConversion
> {
  constructor() {
    super('ProductPriceListConversion', $localize`Product Price List Conversion`);
  }

  getForProduct(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForProduct/${id}`);
  }

  getForProductForm(id: string): Observable<ProductPriceListConversion[]> {
    return this.httpService.get<ProductPriceListConversion[]>(`${this.apiUrl}/GetForProductForm/${id}`);
  }

  getForProductPriceList(id: string, unitOfMeasureId: string): Observable<ProductPriceListConversion> {
    return this.httpService.get<ProductPriceListConversion>(
      `${this.apiUrl}/GetForProductPriceList?id=${id}&orderUnitOfMeasureId=${unitOfMeasureId}`,
    );
  }
}
